var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-footer-wrapper" },
    [
      !_vm.shouldHideConsent
        ? _c("v-checkbox", {
            attrs: {
              rules: _vm.rules.checkbox,
              label: "",
              color: "#0078A7",
              value: "#0078A7",
              dense: "",
              id: "disclaimer"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [
                      _c("p", {
                        staticClass: "check-disclaimer",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.isSingleMemberLLC
                              ? "I agree that I am the sole beneficial owner and controller or manager."
                              : "I understand that by clicking ‘continue’ I certify that I have significant responsibility to control, <br /> manage and direct the business"
                          )
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3224486127
            ),
            model: {
              value: _vm.flags.isChecked,
              callback: function($$v) {
                _vm.$set(_vm.flags, "isChecked", $$v)
              },
              expression: "flags.isChecked"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isSumOwnersPercentValid
        ? _c("div", { staticClass: "error-wrapper" }, [
            _c("span", { staticClass: "error-icon" }),
            _vm._v(" "),
            _c("p", { staticClass: "footer-error" }, [
              _vm._v("Total ownership percentage exceeds 100%")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "partner-business-footer-wrapper" },
        [
          !_vm.isMultiBusinessFlow && !_vm.isMobile
            ? _c(
                "h3",
                {
                  staticClass: "form-footer-back -helper--flex align-center",
                  attrs: { id: "elNavBackDesktop" },
                  on: { click: _vm.handleBack }
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("navBack")) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "main-app-cta active-cta",
              attrs: {
                elevation: "0",
                disabled: !_vm.customerData.incomeType.enum,
                loading: _vm.isLoading,
                type: "submit",
                id: "elCta"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.preSubmit.apply(null, arguments)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("submit")) + "\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-735e25cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-735e25cb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PartnerOnboarding/business-sections/ActionFooter.vue
// module id = null
// module chunks = 